var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _ellipse, _rect7, _circle, _path, _path2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlassPanel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 320",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp-bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FBF5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5EAD4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gp-glass",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3FAF9",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#BFE0DD",
    stopOpacity: 0.55
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 320,
    fill: "url(#gp-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 200,
    width: 280,
    height: 10,
    fill: "#9E2430"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 120,
    width: 280,
    height: 10,
    fill: "#C9A227"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 112,
    width: 80,
    height: 90,
    fill: "url(#gp-glass)",
    stroke: "#C9A227",
    strokeWidth: 3
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    y: 112,
    width: 80,
    height: 90,
    fill: "url(#gp-glass)",
    stroke: "#C9A227",
    strokeWidth: 3
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 112,
    width: 55,
    height: 90,
    fill: "url(#gp-glass)",
    stroke: "#C9A227",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120,
    cy: 108,
    rx: 14,
    ry: 8,
    fill: "#9E2430",
    opacity: 0.8
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 90,
    width: 18,
    height: 22,
    fill: "#821B26",
    opacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 298,
    cy: 100,
    r: 12,
    fill: "#DDB65C",
    opacity: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 120 L130 190",
    stroke: "#ffffff",
    strokeWidth: 6,
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M285 120 L310 190",
    stroke: "#ffffff",
    strokeWidth: 6,
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 270,
    textAnchor: "middle",
    fontFamily: "Georgia, serif",
    fontSize: 14,
    fill: "#4E3F37",
    letterSpacing: 1
  }, "Glass Panels &amp; Shelves")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassPanel);
export default __webpack_public_path__ + "static/media/glass-panel.959a74e09c8cbcf1ca427525b9873108.svg";
export { ForwardRef as ReactComponent };